import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupUnion2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBooleanGroupUnion2"><Path d="M8.5 8.5H2.5V21.5H15.5V15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 15.5H21.5V2.5H8.5V8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 15.5H8.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 8.5H15.5V11.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBooleanGroupUnion2;
